/*
 * Licensed to Jasig under one or more contributor license
 * agreements. See the NOTICE file distributed with this work
 * for additional information regarding copyright ownership.
 * Jasig licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file
 * except in compliance with the License.  You may obtain a
 * copy of the License at the following location:
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
// import styles from 'src/login/cas/css/cas.css';
var regex_title = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
var exponent, modulus, userId;
$(document).ready(function(){
    //focus username field
    $("input:visible:enabled:first").focus();
    //flash error box
    $('#msg.errors').animate({ backgroundColor: 'rgb(187,0,0)' }, 30).animate({ backgroundColor: 'rgb(255,238,221)' }, 500);

    /* 
     * Using the JavaScript Debug library, you may issue log messages such as: 
     * debug.log("Welcome to Central Authentication Service");
     */

	 //判断是否有错误提示信息
	 if($("#msg").hasClass("errors")){
		 var msg = $("#msg").text();
		 if(msg.indexOf('AccountNotFoundException') > 0){
			$("#msg").text("账号不存在，请重新输入!");
		 }else if(msg.indexOf('FailedLoginException')){
			$("#msg").text("账号或密码错误，请重新输入!");
		 }
	 }

	 //为登录按钮绑定click事件,点击登录
	 $(".login_dl").bind('click', function(e) {
	 	e.preventDefault();
	 	var data = chkForm();
	 	window.location.href = "/";

	 	if(data){
	 		//显示loading页面禁用按钮
	 		showLoadImg();
	 		$.ajax({
		 		url: '/wbalone/account/login',
		 		data: data,
		 		dataType: 'json',
		 		method: 'POST',
		 		success: function(res) {
		 			hideLoadImg();
		 			var message={};
		 			if (res.status === "0") {
		 				try {
							var _msg = res.message.replaceAll('\"', '');
							_msg = _msg.split(',');
                            message.msg = _msg[0];  //= JSON.parse(res.message);
							message.status = _msg[1];
                        } catch (e) {
//                          alert(e.name + ": " + e.message);
                            showErrorMsg(res.message);
                            return false;
                        }
                        if (message.status == "50012") {
	                        showErrorMsg(message.msg);
	                        alert(message.msg);
	                        window.open("../../index.html", "_self");
	                        //密码即将过期，修改密码
	                    }
	                    if (message.status == "50006" || message.status == "50007" || message.status == "50009" || message.status == "50010" || message.status == "50011") {
	                        showErrorMsg(message.msg);
	                        //密码即将过期，修改密码
	                    }
	                    showErrorMsg(message.msg);
	                    return false;
		 			}
		 			
		 			//api调用成功
		 			if (res.status == 1) {
		 				//登录成功
						window.open("../../index.html", "_self");
		 			}
		 		},
		 		error: function() {
		 			//api调用失败
		 			hideLoadImg();
		 			showErrorMsg('登录失败，请重试！');
		 		}
	 		});
	 	}
	 });
	 setEncryptParam();
});

/*
 * 设置加密参数
 * */
function setEncryptParam() { //缓存加密参数
//            exponent = $.cookie("exponent");
//            modulus = $.cookie("modulus");
    var uri = '/wbalone/open/getEncryptParam';
    //var uri = "http://172.20.15.98:4042/wbalone/open/getEncryptParam";
    $.ajax({
        type: 'GET',
        dataType: 'json',
        url: uri,
        data: null,
        contentType: 'application/json',
        success: function (res) {
            if (res.status === 1) {
                exponent = res.data.exponent || '';
                modulus = res.data.modulus || '';
//                        if (!$.cookie("exponent")) {
//                            var date = new Date();
//                            date.setTime(date.getTime() + (3 * 24 * 60 * 60 * 1000)); //三天后的这个时候过期
//                            $.cookie("exponent", exponent, { path: '/', expires: date });  //设置3天以后过期
//                            $.cookie("modulus", modulus, { path: '/', expires: date });
                $.cookie("exponent", exponent,{ path: '/'});
                $.cookie("modulus", modulus,{ path: '/'});
//                        }
            } else {
                u.showMessage({showSeconds: 1, width: "32%", msg: "<i class='uf uf-exclamationsign margin-r-5'></i>" + res.msg, position: "center", msgType: "warning"});
            }
        }
    });
}

//检查form表单的用户名和密码格式，若正确则返回
function chkForm(){
	var msg = "",
		data = {};

	data.username = $("#username").val();
	data.password = $("#password").val();
	if(!data.username){
		msg = "用户名不允许为空，请重新输入!";
	}else if(regex_title.test(data.username)){
		msg = "用户名存在非法字符，请重新输入!";
	}else if(!data.password){
		msg = "密码不允许为空，请重新输入!";
	}
	
	if(msg != ""){
		showErrorMsg(msg);
		return false;
	} else {
		userId = data.username;
        var DEdata = {};
        DEdata.text = data.password || '';
        DEdata.exponent = exponent || '';
        DEdata.modulus = modulus || '';

        //data.password = u.RSAUtils.encryptedString(DEdata);
        debugger;
        //var parm = JSON.stringify(data);

		return data;
	}
}

//显示loading页面禁用按钮
function showLoadImg() {
	$(".loading-weizhi").show();
}

//隐藏loading
function hideLoadImg() {
	$(".loading-weizhi").hide();
}

//显示错误提示信息
function showErrorMsg(msg) {
	if(!msg) return;
	var html = "<div class='errors' class='errors' id='msg' >"+msg+"</div>";
	jQuery('#msgPanle').html("");
	jQuery('#msgPanle').append(html).show();
}

function clearForm(){
	$("#username").val("");
	$("#password").val("");
	$("#msg").hide();
}


// WEBPACK FOOTER //
// ./src/login/cas/js/cas.js